module.exports = __webpack_public_path__ + "img/17_maska_kot.bf39ade.svg";